import { render, staticRenderFns } from "./TotalSystemAdmin.vue?vue&type=template&id=2313f0dc&scoped=true"
import script from "./TotalSystemAdmin.vue?vue&type=script&setup=true&lang=ts"
export * from "./TotalSystemAdmin.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TotalSystemAdmin.vue?vue&type=style&index=0&id=2313f0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2313f0dc",
  null
  
)

export default component.exports